import { AuthApiTypes } from 'api'
import { UserRoles } from 'constants/roles'

export enum CreationSource {
  Portal = 'Portal',
  Migrated = 'Migrated',
}

export type LoginState = {
  userData: {
    displayName: string
    companyId: number
    roles: UserRoles[]
    profileUrl?: string
    sessionId?: string
    userName?: string
    accountStatus?: AuthApiTypes.UserInfoResponse['accountStatus']
    sectionsStatuses?: AuthApiTypes.UserInfoResponse['sectionsStatuses']
    migrationSectionsStatuses?: AuthApiTypes.UserInfoResponse['migrationSectionsStatuses']
    currency?: string
    creationSource?: CreationSource
    isProfileAndDocumentsAlreadyApproved?: boolean
  }
  isLoading: boolean
  error?: { message: string; code: string }
  isLoaded: boolean
}

export type LoginRequest = {
  email?: string
  password?: string
  onSuccess?: (role: UserRoles, companyId?: number) => void
  captchaToken?: string | null
}

export type RejectValue = {
  rejectValue: { message: string; code: string }
}
